/* src/components/settings/sections/TimeZoneSettings.js */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-solid-svg-icons';
import {
    SectionCard,
    DropdownInput,
    LoadingSpinner
} from '../SettingSectionComponents';
// TIMEZONE_OPTIONS will be passed as a prop from SettingsPage.js

const TimeZoneSettings = ({
    localTimezone,
    onTimezoneChange, // This will be (e) => setLocalTimezone(e.target.value)
    timezoneOptions, // Passed from SettingsPage.js
    currentLocalTime,
    currentLocalDate,
    isGeneralSectionDisabled,
    isSavingAppSettings,
    appSaveStatus,
    onSaveTimeZone
}) => {
    return (
        <SectionCard title="Time Zone" icon={faClock}>
            <p className="text-sm text-gray-600 mb-4">
                Select your time zone for accurate session timing and progress tracking.
            </p>
            <div className="space-y-3">
                <DropdownInput
                    label="Time Zone"
                    id="timezone"
                    value={localTimezone}
                    onChange={onTimezoneChange} // Directly pass the handler
                    options={timezoneOptions}
                    disabled={isGeneralSectionDisabled}
                    className="mb-2"
                />
                <div className="bg-gray-50 p-3 rounded-md border border-gray-200">
                    <div className="text-sm font-medium text-gray-600">Current Local Time:</div>
                    <div className="mt-1 text-base font-semibold text-gray-700">{currentLocalTime}</div>
                    <div className="mt-1 text-sm text-gray-500">{currentLocalDate}</div>
                </div>
            </div>
            {/* Save Button Area for Time Zone */}
            <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-end space-x-3">
                {appSaveStatus.section === 'timezone' && appSaveStatus.message && (
                    <span className={`text-sm font-medium ${appSaveStatus.type === 'success' ? 'text-green-600' : 'text-red-600'}`}>
                        {appSaveStatus.message}
                    </span>
                )}
                <button
                    onClick={onSaveTimeZone}
                    disabled={isGeneralSectionDisabled}
                    className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 disabled:opacity-50 transition-colors flex items-center justify-center min-w-[150px] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                    {isSavingAppSettings && appSaveStatus.section === 'timezone' ? (
                        <><LoadingSpinner /> Saving...</>
                    ) : (
                        'Save Time Zone'
                    )}
                </button>
            </div>
        </SectionCard>
    );
};

export default TimeZoneSettings;